import Step1 from "../pages/AppWizard/Steps/Versions/v1/Step1";
import Step2 from "../pages/AppWizard/Steps/Versions/v1/Step2";
import Step3 from "../pages/AppWizard/Steps/Versions/v1/Step3";
import Step4 from "../pages/AppWizard/Steps/Versions/v1/Step4";
import Step5 from "../pages/AppWizard/Steps/Versions/v1/Step5";
import Step6 from "../pages/AppWizard/Steps/Versions/v1/Step6";
import Step7 from "../pages/AppWizard/Steps/Versions/v1/Step7";
import Step8 from "../pages/AppWizard/Steps/Versions/v1/Step8";

import _ from 'lodash';
import CDBG2021OhioDuplicativeBenefitsForm from "../pages/AppWizard/Steps/Versions/v1/CDBG2021OhioDuplicativeBenefitsForm";
import CovidHardshipReasons from "../pages/AppWizard/Steps/Versions/v1/CovidHardshipReasons";
import Cares2020Step2 from "../pages/AppWizard/Steps/Versions/v1/Cares2020Step2";
import PropertyAddress from "../pages/AppWizard/Steps/Versions/v1/PropertyAddress";
import OregonThirdPartyAgreement from "../pages/AppWizard/Steps/Versions/v1/OregonThirdPartyAgreement";
import OregonDeclarationOfHardship from "../pages/AppWizard/Steps/Versions/v1/OregonDeclarationOfHardship";

class ApplicationStepResolver {

    constructor() {
        this.steps = [
            {
                key: 'addresses',
                title: 'Property',
                versions: {
                    1: { component: PropertyAddress, }
                }
            },
            {
                key: 'applicant',
                title: 'Applicant',
                versions: {
                    1: { component: require('../pages/AppWizard/Steps/Versions/v1/Step1').default },
                    2: { component: require('../pages/AppWizard/Steps/Versions/v2/Step1').default },
                    3: { component: require('../pages/AppWizard/Steps/Versions/v3/Step1').default },
                    merap: { component: require('../pages/AppWizard/Steps/Versions/merap/Step1').default },
                }
            },
            {
                key: 'ledger-verification',
                title: 'Assistance',
                versions: {
                    1: { component: require('../pages/AppWizard/Steps/Versions/v1/LedgerVerificationWithNotes').default },
                }

            },
            {
                key: 'property',
                title: 'Assistance',
                versions: {
                    1: { component: Step2, },
                    2: { component: require('../pages/AppWizard/Steps/Versions/v2/Step2').default },
                    3: { component: require('../pages/AppWizard/Steps/Versions/v3/Step2').default },
                }
            },
            {
                key: 'income',
                title: 'Income',
                versions: {
                    1: { component: Step3, },
                    3: { component: require('../pages/AppWizard/Steps/Versions/v3/Step3').default, },
                    4: { component: require('../pages/AppWizard/Steps/Versions/v4/Step3').default, },
                    5: { component: require('../pages/AppWizard/Steps/Versions/pathway/Step3').default, },
                }
            },
            {
                key: 'hardship',
                title: 'Hardship Affidavit',
                versions: {
                    1: { component: Step4, },
                }
            },
            {
                key: 'privacy',
                title: 'Privacy Policy',
                versions: {
                    1: { component: Step5, },
                    3: { component: require('../pages/AppWizard/Steps/Versions/v3/PrivacyPolicy').default},
                    mrap: { component: require('../pages/AppWizard/Steps/Versions/mrap/PrivacyPolicy').default},
                    kera: { component: require('../pages/AppWizard/Steps/Versions/kera/PrivacyPolicy').default},
                    merap: { component: require('../pages/AppWizard/Steps/Versions/merap/PrivacyPolicy').default},
                    ohera: { component: require('../pages/AppWizard/Steps/Versions/ohera/PrivacyPolicy').default},
                    riera: { component: require('../pages/AppWizard/Steps/Versions/riera/PrivacyPolicy').default},
                    dera: { component: require('../pages/AppWizard/Steps/Versions/dera/PrivacyPolicy').default},
                    orera: { component: require('../pages/AppWizard/Steps/Versions/orera/PrivacyPolicy').default},
                    eraprogram: { component: require('../pages/AppWizard/Steps/Versions/eraprogram/PrivacyPolicy').default},


                }
            },
            {
                key: 'terms-conditions',
                title: 'Terms & Conditions',
                versions: {
                    1: { component: Step6, },
                    3: { component: require('../pages/AppWizard/Steps/Versions/v3/TermsAndConditions').default},
                    mrap: { component: require('../pages/AppWizard/Steps/Versions/mrap/TermsAndConditions').default},
                    kera: { component: require('../pages/AppWizard/Steps/Versions/kera/TermsAndConditions').default},
                    merap: { component: require('../pages/AppWizard/Steps/Versions/merap/TermsAndConditions').default},
                    ohera: { component: require('../pages/AppWizard/Steps/Versions/ohera/TermsAndConditions').default},
                    riera: { component: require('../pages/AppWizard/Steps/Versions/riera/TermsAndConditions').default},
                    dera: { component: require('../pages/AppWizard/Steps/Versions/dera/TermsAndConditions').default},
                    orera: { component: require('../pages/AppWizard/Steps/Versions/orera/TermsAndConditions').default},
                    eraprogram: { component: require('../pages/AppWizard/Steps/Versions/eraprogram/TermsAndConditions').default}
                }
            },
            {
                key: 'tenant-certification',
                title: 'Tenant Certification',
                versions: {
                    kera: { component: require('../pages/AppWizard/Steps/Versions/kera/TermsAndConditions').default},
                }
            },
            {
                key: 'tpa',
                title: 'Third-Party Authorization',
                versions: {
                    1: { component: Step7, },
                    3: { component: require('../pages/AppWizard/Steps/Versions/v3/ThirdPartyAuthorization').default},
                    mrap: { component: require('../pages/AppWizard/Steps/Versions/mrap/ThirdPartyAuthorization').default},
                    kera: { component: require('../pages/AppWizard/Steps/Versions/kera/ThirdPartyAuthorization').default},
                    merap: { component: require('../pages/AppWizard/Steps/Versions/merap/ThirdPartyAuthorization').default},
                    ohera: { component: require('../pages/AppWizard/Steps/Versions/ohera/ThirdPartyAuthorization').default},
                    riera: { component: require('../pages/AppWizard/Steps/Versions/riera/ThirdPartyAuthorization').default},
                    dera: { component: require('../pages/AppWizard/Steps/Versions/dera/ThirdPartyAuthorization').default},
                    orera: { component: require('../pages/AppWizard/Steps/Versions/orera/ThirdPartyAuthorization').default},
                    eraprogram: { component: require('../pages/AppWizard/Steps/Versions/eraprogram/ThirdPartyAuthorization').default},
                }
            },
            {
                key: 'documents',
                title: 'Package Submission',
                versions: {
                    1: { component: Step8, },
                }
            },

            {
                key: 'cdbg-duplicative-2021',
                title: 'Duplicate Benefits',
                versions: {
                    1: { component: CDBG2021OhioDuplicativeBenefitsForm, },
                }
            },

            {
                key: 'hardship-reasons',
                title: 'COVID-19 Hardship',
                versions: {
                    1: { component: require('../pages/AppWizard/Steps/Versions/v1/CovidHardshipReasons.vue').default, },
                    mrap: { component: require('../pages/AppWizard/Steps/Versions/mrap/CovidHardshipReasons.vue').default },
                    kera: { component: require('../pages/AppWizard/Steps/Versions/kera/CovidHardshipReasons.vue').default },
                    merap: { component: require('../pages/AppWizard/Steps/Versions/merap/CovidHardshipReasons.vue').default },
                    ohera: { component: require('../pages/AppWizard/Steps/Versions/ohera/CovidHardshipReasons.vue').default },
                    riera: { component: require('../pages/AppWizard/Steps/Versions/riera/CovidHardshipReasons.vue').default },
                    dera: { component: require('../pages/AppWizard/Steps/Versions/dera/CovidHardshipReasons.vue').default },
                    orera: { component: require('../pages/AppWizard/Steps/Versions/orera/CovidHardshipReasons.vue').default },
                    eraprogram: { component: require('../pages/AppWizard/Steps/Versions/eraprogram/CovidHardshipReasons.vue').default },
                }
            },

            {
                key: 'oregon-hardship-declaration',
                title: 'Hardship Declaration',
                versions: {
                    1: { component: OregonDeclarationOfHardship, },
                }
            },

            {
                key: 'era-duplicative-form',
                title: 'Duplicative Benefits',
                versions: {
                    1: { component: require('../pages/AppWizard/Steps/Versions/v1/DuplicativeBenefitsForm').default },
                    mrap: { component: require('../pages/AppWizard/Steps/Versions/mrap/DuplicativeBenefitsForm').default },
                    kera: { component: require('../pages/AppWizard/Steps/Versions/kera/DuplicativeBenefitsForm').default },
                    merap: { component: require('../pages/AppWizard/Steps/Versions/merap/DuplicativeBenefitsForm').default },
                    ohera: { component: require('../pages/AppWizard/Steps/Versions/ohera/DuplicativeBenefitsForm').default },
                    riera: { component: require('../pages/AppWizard/Steps/Versions/riera/DuplicativeBenefitsForm').default },
                    dera: { component: require('../pages/AppWizard/Steps/Versions/dera/DuplicativeBenefitsForm').default },
                    orera: { component: require('../pages/AppWizard/Steps/Versions/orera/DuplicativeBenefitsForm').default },
                    eraprogram: { component: require('../pages/AppWizard/Steps/Versions/eraprogram/DuplicativeBenefitsForm').default },
                }
            },

            {
                key: 'cdbg-step-2',
                title: 'Property',
                versions: {
                    1: { component: Cares2020Step2, },
                }
            },

            {
                key: 'orgeon-tpa',
                title: 'Third Party Agreement',
                versions: {
                    1: { component: OregonThirdPartyAgreement }
                }
            }


        ];
    }

    fromPages(pageKeys) {
        let _steps = [];
        _.each(pageKeys, key => {

            // Split page key to check for a version
            let _key = key;
            let version = 1;
            let pageKeyArray = key.split('_');
            if(pageKeyArray.length > 1) {
                _key = pageKeyArray[0];
                version = pageKeyArray[1];
            }

            _.each(this.steps, step => {

                if(step.key === _key) {
                    if(step.versions[version] === undefined) {
                        throw 'The step with key "' + _key + '" does not have a version defined for ' + version;
                    }

                    let _step = {
                        key: step.key,
                        title: step.title,
                        component: step.versions[version].component,
                    }
                    _steps.push(_step);
                }
            })
        })
        return _steps;
    }

    defaultPages() {
        let keys = ["applicant", "property", "income", "hardship", "privacy", "terms-conditions", "tpa", "documents"];
        return this.fromPages(keys);
    }
}

export default ApplicationStepResolver
